import React, { FC, useEffect } from 'react';

import { AirdropMeBanner, MeCardList } from '@widget/airdrop';

import { useMePaging } from '../hooks';
export const MePage: FC = () => {
  const { historyData, fetchHistoryData } = useMePaging();
  useEffect(() => {
    fetchHistoryData();
  }, []);
  return (
    <div>
        <AirdropMeBanner historyData={historyData} />
        <MeCardList fetchData={fetchHistoryData}/>
    </div>
  );
};
